export default __webpack_public_path__ + "static/media/successIcon.94e08b33.svg";